/**
 * Contextual hints for Drops list load failures.
 * For Media Devoted | Created By Ciro Autiero
 */

export function getDropsErrorHint(
  errorText: string,
  options?: { dateRangeFetch?: boolean },
): string | null {
  if (!errorText) return null;

  const lower = errorText.toLowerCase();

  if (lower.includes('puppeteer') || lower.includes('auth server')) {
    return 'SMSWiser login requires the Puppeteer auth server. Make sure it is running and reachable on localhost.';
  }

  if (lower.includes('authentication failed')) {
    return 'SMSWiser authentication failed. Check SMSWISER credentials and try again.';
  }

  if (lower.includes('length must not be greater than 5000')) {
    return 'Fetch target is only an estimate for date ranges — the request should not send that value to the API. Try Fetch again.';
  }

  if (lower.includes('timeout')) {
    if (options?.dateRangeFetch) {
      return 'Date-range loads paginate SMSWiser in 5k chunks and can take several minutes. Wait a moment, then try Fetch again.';
    }
    return 'SMSWiser is slow to respond right now. This can happen during session refresh/login. Try again in a moment.';
  }

  return null;
}
